import React from 'react';

const Research = () => (
    <div>
        <h2>Research and Publications</h2>
        <p>
            My research focuses on addressing critical healthcare challenges, including cardiovascular diseases, geriatric nutrition, and neurodegenerative conditions. I have actively contributed to medical knowledge through published studies, poster presentations, and participation in academic workshops.
        </p>
        <h3>Research Works</h3>
        <ul>
            <li>
                <strong>Effect of different blood groups on Cardiovascular Diseases: </strong>
                Investigating the impact of blood groups on cardiovascular health and potential risks.
            </li>
            <li>
                <strong>A mini health check-up for women for early detection of non-communicable diseases: </strong>
                Organized and conducted health check-ups to identify early signs of chronic illnesses in women.
            </li>
            <li>
                <strong>Prevalence of rotavirus infection in children below 5 years with acute gastroenteritis in an urban teaching hospital: </strong>
                Research on rotavirus prevalence and its effects in young children.
            </li>
            <li>
                <strong>Assessment of nutritional status in geriatric age group: </strong>
                Studied the nutrition levels and related health challenges in elderly populations.
            </li>
            <li>
                <strong>Role of calcium channel blockers in preventing neurodegenerative changes of nerve head: </strong>
                Examined their effectiveness in raising diastolic perfusion pressure in open-angle glaucoma patients.
            </li>
        </ul>
        <h3>Publications</h3>
        <ul>
            <li>
                <strong>A study on prevalence of rotavirus infection in children below 5 years with acute gastroenteritis: </strong>
                Published in the International Journal of Community Medicine and Public Health.
            </li>
            <li>
                <strong>Nutritional status of elderly people using mini nutritional assessment tool in urban slum of Hyderabad: </strong>
                Published in the International Journal of Medical Sciences and Public Health.
            </li>
            <li>
                <strong>Prevalence of modifiable lifestyle habits with hemorrhoids - A cross-sectional study: </strong>
                Published in the International Journal of Health and Clinical Research.
            </li>
        </ul>
        <h3>Poster Presentations</h3>
        <ul>
            <li>
                <strong>Prevalence of Rotavirus Infection in Children: </strong>
                Presented at AIMSR in 2016, awarded 3rd prize.
            </li>
        </ul>
    </div>
);

export default Research;
